import './Contact.scss'
import React from 'react'
import classes from './Contact.module.less'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'

export const Contact: React.FC<{}> = () => {
  const { t } = useTranslation()
  return (
    <div className={classes['contact']}>
      <Helmet>
        <title>Contact | Sophie</title>
      </Helmet>
      <section className="contact-section">
        <div>
          <div className="doctor-service-1">
            <span>{t('CONTACT.CONTACT_WITH')} </span>
            <span className="online">{t('CONTACT.SHOPIE')}</span>
          </div>

          <p className="sub-title color-grey">{t('CONTACT.QUESTION')}</p>
          <div className="contact-content">
            <div className="row">
              <div className="col-md-4 col-lg-4 contact-content-item">
                <div className="row">
                  <div className="col-md-2 col-lg-2 col-sm-1 col-2">
                    <div className="contact-content-icon">
                      <div className="contact-svg">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.1995 9.98633C11.4529 9.98633 10.8662 10.5863 10.8662 11.3197C10.8662 12.053 11.4662 12.653 12.1995 12.653C12.9329 12.653 13.5329 12.053 13.5329 11.3197C13.5329 10.5863 12.9329 9.98633 12.1995 9.98633Z"
                            fill="#1A9CC6"
                          />
                          <path
                            d="M28.6137 6.72033C27.4937 4.12033 25.027 2.66699 21.587 2.66699H10.4137C6.13366 2.66699 2.66699 6.13366 2.66699 10.4137V21.587C2.66699 25.027 4.12033 27.4937 6.72033 28.6137C6.97366 28.7203 7.26699 28.6537 7.45366 28.467L28.467 7.45366C28.667 7.25366 28.7337 6.96033 28.6137 6.72033ZM14.0403 16.3203C13.5203 16.827 12.8403 17.067 12.1603 17.067C11.4803 17.067 10.8003 16.8137 10.2803 16.3203C8.92033 15.0403 7.42699 13.0003 8.00033 10.5737C8.50699 8.37366 10.4537 7.38699 12.1603 7.38699C13.867 7.38699 15.8137 8.37366 16.3203 10.587C16.8803 13.0003 15.387 15.0403 14.0403 16.3203Z"
                            fill="#1A9CC6"
                          />
                          <path
                            d="M25.9595 27.3737C26.2529 27.667 26.2129 28.147 25.8529 28.347C24.6795 29.0004 23.2529 29.3337 21.5862 29.3337H10.4129C10.0262 29.3337 9.8662 28.8804 10.1329 28.6137L18.1862 20.5604C18.4529 20.2937 18.8662 20.2937 19.1329 20.5604L25.9595 27.3737Z"
                            fill="#1A9CC6"
                          />
                          <path
                            d="M29.3333 10.4129V21.5862C29.3333 23.2529 29 24.6929 28.3467 25.8529C28.1467 26.2129 27.6667 26.2395 27.3733 25.9595L20.5467 19.1329C20.28 18.8662 20.28 18.4529 20.5467 18.1862L28.6 10.1329C28.88 9.8662 29.3333 10.0262 29.3333 10.4129Z"
                            fill="#1A9CC6"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-10 col-lg-10 col-sm-9 col-10">
                    <div className="contact-content-detail">
                      <p> {t('CONTACT.ADDRESS')}</p>
                      <span>{t('CONTACT.DETAIL_ADDRESS')}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-lg-4 contact-content-item">
                <div className="row">
                  <div className="col-md-2 col-lg-2 col-sm-1 col-2">
                    <div className="contact-content-icon">
                      <div className="contact-svg">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M26.6667 9.00033C28.6917 9.00033 30.3333 7.3587 30.3333 5.33366C30.3333 3.30861 28.6917 1.66699 26.6667 1.66699C24.6416 1.66699 23 3.30861 23 5.33366C23 7.3587 24.6416 9.00033 26.6667 9.00033Z"
                            fill="#1A9CC6"
                          />
                          <path
                            d="M25.387 10.867C23.2937 10.4137 21.587 8.70699 21.1337 6.61366C20.9603 5.80033 20.947 5.01366 21.0937 4.26699C21.267 3.44033 20.6537 2.66699 19.8003 2.66699H9.33366C5.65366 2.66699 2.66699 5.65366 2.66699 9.33366V18.6003C2.66699 22.2803 5.65366 25.267 9.33366 25.267H11.3337C11.707 25.267 12.187 25.507 12.4003 25.8003L14.4003 28.4537C15.2803 29.627 16.7203 29.627 17.6003 28.4537L19.6003 25.8003C19.8537 25.467 20.2403 25.267 20.667 25.267H22.6803C26.3603 25.267 29.3337 22.2937 29.3337 18.6137V12.2003C29.3337 11.3603 28.5603 10.747 27.7337 10.907C26.987 11.0403 26.2003 11.0403 25.387 10.867ZM10.667 16.0003C9.92033 16.0003 9.33366 15.4003 9.33366 14.667C9.33366 13.9337 9.92033 13.3337 10.667 13.3337C11.4003 13.3337 12.0003 13.9337 12.0003 14.667C12.0003 15.4003 11.4137 16.0003 10.667 16.0003ZM16.0003 16.0003C15.2537 16.0003 14.667 15.4003 14.667 14.667C14.667 13.9337 15.2537 13.3337 16.0003 13.3337C16.7337 13.3337 17.3337 13.9337 17.3337 14.667C17.3337 15.4003 16.747 16.0003 16.0003 16.0003ZM21.3337 16.0003C20.587 16.0003 20.0003 15.4003 20.0003 14.667C20.0003 13.9337 20.587 13.3337 21.3337 13.3337C22.067 13.3337 22.667 13.9337 22.667 14.667C22.667 15.4003 22.0803 16.0003 21.3337 16.0003Z"
                            fill="#1A9CC6"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-10 col-lg-10 col-sm-9 col-10">
                    <div className="contact-content-detail">
                      <p> {t('CONTACT.CONTACT_SUPPORT')} </p>
                      <span>{t('CONTACT.NUMBER')}</span>
                      <br />
                      <span>{t('CONTACT.MAIL')}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-lg-4 contact-content-item">
                <div className="row">
                  <div className="col-md-2 col-lg-2 col-sm-1 col-2">
                    <div className="contact-content-icon">
                      <div className="contact-svg">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22.3333 4.74699V2.66699C22.3333 2.12033 21.88 1.66699 21.3333 1.66699C20.7866 1.66699 20.3333 2.12033 20.3333 2.66699V4.66699H11.6666V2.66699C11.6666 2.12033 11.2133 1.66699 10.6666 1.66699C10.12 1.66699 9.66665 2.12033 9.66665 2.66699V4.74699C6.06665 5.08033 4.31998 7.22699 4.05331 10.4137C4.02665 10.8003 4.34665 11.1203 4.71998 11.1203H27.28C27.6666 11.1203 27.9866 10.787 27.9466 10.4137C27.68 7.22699 25.9333 5.08033 22.3333 4.74699Z"
                            fill="#1A9CC6"
                          />
                          <path
                            d="M26.6667 13.1201H5.33333C4.6 13.1201 4 13.7201 4 14.4535V22.6668C4 26.6668 6 29.3335 10.6667 29.3335H21.3333C26 29.3335 28 26.6668 28 22.6668V14.4535C28 13.7201 27.4 13.1201 26.6667 13.1201ZM12.28 24.2801C12.2133 24.3334 12.1467 24.4001 12.08 24.4401C12 24.4935 11.92 24.5335 11.84 24.5601C11.76 24.6001 11.68 24.6268 11.6 24.6401C11.5067 24.6535 11.4267 24.6668 11.3333 24.6668C11.16 24.6668 10.9867 24.6268 10.8267 24.5601C10.6533 24.4935 10.52 24.4001 10.3867 24.2801C10.1467 24.0268 10 23.6801 10 23.3335C10 22.9868 10.1467 22.6401 10.3867 22.3868C10.52 22.2668 10.6533 22.1735 10.8267 22.1068C11.0667 22.0001 11.3333 21.9735 11.6 22.0268C11.68 22.0401 11.76 22.0668 11.84 22.1068C11.92 22.1335 12 22.1735 12.08 22.2268C12.1467 22.2801 12.2133 22.3335 12.28 22.3868C12.52 22.6401 12.6667 22.9868 12.6667 23.3335C12.6667 23.6801 12.52 24.0268 12.28 24.2801ZM12.28 19.6135C12.0267 19.8535 11.68 20.0001 11.3333 20.0001C10.9867 20.0001 10.64 19.8535 10.3867 19.6135C10.1467 19.3601 10 19.0135 10 18.6668C10 18.3201 10.1467 17.9735 10.3867 17.7201C10.76 17.3468 11.3467 17.2268 11.84 17.4401C12.0133 17.5068 12.16 17.6001 12.28 17.7201C12.52 17.9735 12.6667 18.3201 12.6667 18.6668C12.6667 19.0135 12.52 19.3601 12.28 19.6135ZM16.9467 24.2801C16.6933 24.5201 16.3467 24.6668 16 24.6668C15.6533 24.6668 15.3067 24.5201 15.0533 24.2801C14.8133 24.0268 14.6667 23.6801 14.6667 23.3335C14.6667 22.9868 14.8133 22.6401 15.0533 22.3868C15.5467 21.8935 16.4533 21.8935 16.9467 22.3868C17.1867 22.6401 17.3333 22.9868 17.3333 23.3335C17.3333 23.6801 17.1867 24.0268 16.9467 24.2801ZM16.9467 19.6135C16.88 19.6668 16.8133 19.7201 16.7467 19.7735C16.6667 19.8268 16.5867 19.8668 16.5067 19.8935C16.4267 19.9335 16.3467 19.9601 16.2667 19.9734C16.1733 19.9868 16.0933 20.0001 16 20.0001C15.6533 20.0001 15.3067 19.8535 15.0533 19.6135C14.8133 19.3601 14.6667 19.0135 14.6667 18.6668C14.6667 18.3201 14.8133 17.9735 15.0533 17.7201C15.1733 17.6001 15.32 17.5068 15.4933 17.4401C15.9867 17.2268 16.5733 17.3468 16.9467 17.7201C17.1867 17.9735 17.3333 18.3201 17.3333 18.6668C17.3333 19.0135 17.1867 19.3601 16.9467 19.6135ZM21.6133 24.2801C21.36 24.5201 21.0133 24.6668 20.6667 24.6668C20.32 24.6668 19.9733 24.5201 19.72 24.2801C19.48 24.0268 19.3333 23.6801 19.3333 23.3335C19.3333 22.9868 19.48 22.6401 19.72 22.3868C20.2133 21.8935 21.12 21.8935 21.6133 22.3868C21.8533 22.6401 22 22.9868 22 23.3335C22 23.6801 21.8533 24.0268 21.6133 24.2801ZM21.6133 19.6135C21.5467 19.6668 21.48 19.7201 21.4133 19.7735C21.3333 19.8268 21.2533 19.8668 21.1733 19.8935C21.0933 19.9335 21.0133 19.9601 20.9333 19.9734C20.84 19.9868 20.7467 20.0001 20.6667 20.0001C20.32 20.0001 19.9733 19.8535 19.72 19.6135C19.48 19.3601 19.3333 19.0135 19.3333 18.6668C19.3333 18.3201 19.48 17.9735 19.72 17.7201C19.8533 17.6001 19.9867 17.5068 20.16 17.4401C20.4 17.3335 20.6667 17.3068 20.9333 17.3601C21.0133 17.3735 21.0933 17.4001 21.1733 17.4401C21.2533 17.4668 21.3333 17.5068 21.4133 17.5601C21.48 17.6135 21.5467 17.6668 21.6133 17.7201C21.8533 17.9735 22 18.3201 22 18.6668C22 19.0135 21.8533 19.3601 21.6133 19.6135Z"
                            fill="#1A9CC6"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-10 col-lg-10 col-sm-9 col-10">
                    <div className="contact-content-detail">
                      <p>{t('CONTACT.WORKING_TIME')}</p>
                      <span>
                        <b> {t('CONTACT.TIME')}</b> {t('CONTACT.TIME_AT')}
                      </span>
                      <br />
                      <span>
                        <b> {t('CONTACT.TIME_ON')}</b> {t('CONTACT.TIME_FOR')}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="map-sophie">
          <iframe
            title="This is a unique title"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.6079698965464!2d106.72368345081345!3d10.841283392239648!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3175275a21aec0ef%3A0x653837fd33e95972!2sSophie%20Healthcare%20Vi%E1%BB%87t%20Nam!5e0!3m2!1svi!2s!4v1663053559143!5m2!1svi!2s"
            width="100%"
            height="450"
            style={{ border: 0 }}
            // allowfullscreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  )
}

export default Contact
